import { cssRule, media, style, stylesheet } from 'typestyle';
import { Gray20, Gray50 } from '@traceair/tds';

export const BREAKPOINT_SMALL = 600;
export const BREAKPOINT_MEDIUM = 820;
export const BREAKPOINT_LARGE = 1260;

export const CONTAINER_PADDINGS = {
  paddingTop: 0,
  paddingRight: 32,
  paddingBottom: 24,
  paddingLeft: 32,
};

export const MOBILE_CONTAINER_PADDINGS = {
  padding: 12,
};

export const containerStyles = stylesheet({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  containerInner: {
    overflow: 'auto',
    flex: '1 1 auto',
    ...CONTAINER_PADDINGS,
    ...media({ maxWidth: BREAKPOINT_SMALL }, { ...MOBILE_CONTAINER_PADDINGS }),
  },
});

// TDS Tooltip puts padding on the outer `.ant-tooltip` wrapper, which has the
// visible rounded background. antd's inner `.ant-tooltip-inner` keeps its own
// (slightly different) borderRadius and shows through near the edges as a
// faint extra rounded shape. Moving padding from the outer to the inner makes
// the visible background hug the content directly. `&&` raises specificity so
// this wins over TDS's defaultInnerContentOverlayStyle (padding: 8 on outer).
export const tooltipOverlayClass = style({
  $nest: {
    '&&': {
      padding: 0,
    },
    '&& .ant-tooltip-inner': {
      padding: 8,
    },
  },
});

cssRule('body', {
  $nest: {
    '@media (hover: hover), (pointer: fine)': {
      $nest: {
        '::-webkit-scrollbar': {
          width: 8,
          height: 8,
          background: Gray20,
        },
        '::-webkit-scrollbar-thumb': {
          background: Gray50,
        },
      },
    },
  },
});
